<h1 mat-dialog-title *ngIf="title !== ''">{{ title }}</h1>
<div mat-dialog-content *ngIf="message !== ''" [innerHTML]="message"></div>
<div mat-dialog-actions class="simple-actions">

    <div *ngFor="let action of actions">
        <button mat-raised-button *ngIf="action.raised" (click)="resolve(action.result)" [color]="action.color ? action.color : ''">{{ action.label }}</button>
        <button mat-button *ngIf="!action.raised" (click)="resolve(action.result)" [color]="action.color ? action.color : ''">{{ action.label }}</button>
    </div>

</div>